<template>
    
    <div>
      <animatedLogo style="margin-top: 20vh" />

      <p style="text-align: center; margin-top: 15vh;">
        <router-link to="/peter">
          <button class="primary big-xl">Commencer</button>
        </router-link>
      </p>
    </div>
</template>

<script>
import animatedLogo from '@/components/animatedLogo'

export default {
  name: 'primary',
  components: {
    animatedLogo
  },

  mounted: function () {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#964db9')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/primary.vue